import { isFlightProvidedByAdmin } from "Models/User";
import { FlightFormOutput } from "./schema";

export const FlightModel = {
  default: (
    userId: number | string,
    companions: Array<number | { id: number }> | null,
    outbound_flight_type: number,
    return_flight_type?: string | number,
    overwriteProps = {},
  ): FlightFormOutput & { user_id: string | number } => ({
    // overall common fields
    companion_ids:
      companions && Array.isArray(companions)
        ? companions.map((c) => (typeof c === "number" ? c : c.id))
        : [],
    user_id: userId,
    other_notes: "",
    has_user: true,
    is_user_verify_all_information: true,
    // outbound common fields
    outbound_flight_type: outbound_flight_type
      ? isFlightProvidedByAdmin(outbound_flight_type)
        ? "1"
        : "2"
      : "2",
    outbound_departure_date: "",
    outbound_arrival_date: "",
    outbound_departure_time: "",
    outbound_arrival_time: "",
    outbound_duration_hours: "",
    outbound_duration_minutes: "",
    // outbound commercial
    outbound_cabin: "",
    outbound_flight_number: "",
    outbound_flight_pnr: "",
    outbound_departure_airport_code: "",
    outbound_departure_airport_name: "",
    outbound_arrival_airport_code: "",
    outbound_arrival_airport_name: "",
    // outbound private jet
    outbound_order_number: "",
    outbound_aircraft: "",
    outbound_tail_number: "",
    outbound_call_sign: "",
    outbound_operator: "",
    outbound_departure_location: "",
    outbound_arrival_location: "",
    outbound_handling_agents_country_code: "",
    outbound_handling_agents: "",
    outbound_handling_agents_contact_number: "",
    // return common fields
    return_flight_type: return_flight_type
      ? isFlightProvidedByAdmin(return_flight_type)
        ? "1"
        : "2"
      : "0",
    return_departure_date: "",
    return_arrival_date: "",
    return_departure_time: "",
    return_arrival_time: "",
    return_duration_hours: "",
    return_duration_minutes: "",
    // return commercial jet
    return_flight_number: "",
    return_flight_pnr: "",
    return_departure_airport_code: "",
    return_departure_airport_name: "",
    return_arrival_airport_code: "",
    return_arrival_airport_name: "",
    return_cabin: "",
    // return private jet
    return_order_number: "",
    return_aircraft: "",
    return_tail_number: "",
    return_call_sign: "",
    return_operator: "",
    return_handling_agents: "",
    return_handling_agents_contact_number: "",
    return_departure_location: "",
    return_arrival_location: "",
    return_handling_agents_country_code: "",
    admin_notes: "",
    flight_ticket: "",
    ...overwriteProps,
  }),
  apply: (flight: any): FlightFormOutput => ({
    ...flight,
    has_user: flight.has_user,
    companion_ids: flight.companions.map((c: any) => c?.id),
    outbound_flight_type: flight.outbound_flight_type?.toString(),
    return_flight_type: flight.return_flight_type?.toString(),
    outbound_order_number: flight.outbound_order_number,
    outbound_aircraft: flight.outbound_aircraft,
    outbound_tail_number: flight.outbound_tail_number,
    outbound_call_sign: flight.outbound_call_sign,
    outbound_operator: flight.outbound_operator,
    outbound_handling_agents: flight.outbound_handling_agents,
    outbound_departure_location: flight.outbound_departure_location,
    outbound_arrival_location: flight.outbound_arrival_location,
    outbound_handling_agents_country_code:
      flight.outbound_handling_agents_country_code,
    return_order_number: flight.return_order_number,
    return_aircraft: flight.return_aircraft,
    return_tail_number: flight.return_tail_number,
    return_call_sign: flight.return_call_sign,
    return_operator: flight.return_operator,
    return_handling_agents: flight.return_handling_agents,
    return_departure_location: flight.return_departure_location,
    return_arrival_location: flight.return_arrival_location,
    return_handling_agents_country_code:
      flight.return_handling_agents_country_code,
    outbound_departure_airport_code: flight.outbound_departure_airport_code,
    outbound_departure_airport_name: flight.outbound_departure_airport_name,
    outbound_arrival_airport_code: flight.outbound_arrival_airport_code,
    outbound_arrival_airport_name: flight.outbound_arrival_airport_name,
    outbound_flight_number: flight.outbound_flight_number,
    outbound_departure_time: flight.outbound_departure_time,
    outbound_arrival_time: flight.outbound_arrival_time,
    outbound_departure_date: flight.outbound_departure_date,
    outbound_arrival_date: flight.outbound_arrival_date,
    outbound_flight_pnr: flight.outbound_flight_pnr,
    outbound_cabin: flight.outbound_cabin,
    return_departure_time: flight.return_departure_time,
    return_arrival_time: flight.return_arrival_time,
    return_departure_date: flight.return_departure_date,
    return_arrival_date: flight.return_arrival_date,
    return_flight_pnr: flight.return_flight_pnr,
    return_cabin: flight.return_cabin,
    return_departure_airport_code: flight.return_departure_airport_code,
    return_departure_airport_name: flight.return_departure_airport_name,
    return_arrival_airport_code: flight.return_arrival_airport_code,
    return_arrival_airport_name: flight.return_arrival_airport_name,
    return_flight_number: flight.return_flight_number,
    other_notes: flight.other_notes,
    admin_notes: flight.admin_notes,
    is_user_verify_all_information: flight.is_user_verify_all_information,
    flight_ticket: flight.outbound_flight_pdf,
  }),
};
